var session=null;
var existingProductIds=[];
class newRecharge {

    header() {
        return {
            "Content-Type": "application/json",
            "X-Recharge-Access-Token": session.apiToken,
            "X-Recharge-Version": "2021-11"
        };
    }

    rechargeCommonApi(){
        return window.customerDetails.rechargeCommonApi
    }
    
    shopifyCommonApi(){
        return window.customerDetails.shopifyCommonApi
    }

    rechargeCommonBody(config){
        return {
            method: 'POST',
            headers: this.header(),
            body: JSON.stringify(config)
        }
    }

    async _authCustomer(){
        session = await recharge.auth.loginShopifyAppProxy();
    }
    async _getCustomerDetails() {

        if (session.customerId != null) {
          const response= await recharge.customer.getCustomer(session, { include: ['addresses','payment_methods','subscriptions'] });
          window.customerDetails.rechargeCustomerDetails=response;
          return window.customerDetails.rechargeCustomerDetails;
        }else{
          return false
        }
    }

    async _getSubscriptions() {
        existingProductIds=[];
        const response= await recharge.subscription.listSubscriptions(session, {
            limit: 50,
            status: 'active',
            sort_by: 'id-asc',
        });
        window.customerDetails.rechargeSubscriptions=response.subscriptions;
        window.customerDetails.rechargeSubscriptions.sort((a, b) => {{
            if (a.next_charge_scheduled_at == null) return 1;
            if (b.next_charge_scheduled_at == null) return -1;
            return new Date(a.next_charge_scheduled_at) - new Date(b.next_charge_scheduled_at);
        }});

        existingProductIds=[...existingProductIds,...window.customerDetails.rechargeSubscriptions.map((sub)=>{return sub.external_product_id ? sub.external_product_id.ecommerce : sub.shopify_product_id })]

        return window.customerDetails.rechargeSubscriptions;
    }

    async _getOnetimes() {
        const response= await recharge.onetime.listOnetimes(session, {
            limit: 100,
            sort_by: 'id-asc',
        });
        window.customerDetails.rechargeOnetimes=response.onetimes;
        existingProductIds=[...existingProductIds,...window.customerDetails.rechargeOnetimes.map((sub)=>{return sub.external_product_id ? sub.external_product_id.ecommerce : sub.shopify_product_id })]

        return window.customerDetails.rechargeOnetimes;
    }
    
    async _getCustomerAddresses() {
        const response= await recharge.address.listAddresses(session, {
            limit: 25,
            sort_by: 'id-asc',
        });
        window.customerDetails.rechargeCustomerAddress=response.addresses;
        return window.customerDetails.rechargeCustomerAddress;
    }

    async _getProductsJSON() {

        var config = {
            url: `/products.json`,
            method: 'GET',
            data: {
                'ids': existingProductIds.toString()
            }
        };
        const response = await fetch(this.shopifyCommonApi(), this.rechargeCommonBody(config));
        const data = await response.json();

        var productsJson = [];
        productsJson = data.products;
        productsJson.map((item, i) => {
            let obj={};
            item.variants.map((variant)=>{
                variant['options']=[{value:variant.option1},{value:variant.option2}];
                obj[variant.id]=variant
                
            })
            productsJson[i].variants=obj;
            productsJson[i]['type']=item.product_type;
            

        });
        let obj1={}
        productsJson.map((item, i) => {
            obj1[item.id] = item;
        });
        productsJson = obj1;

        if (response.ok) {
            console.log('Products Json : ',data)
            window.customerDetails.shopifyProductsJSON=productsJson;
            return await window.customerDetails.shopifyProductsJSON
        }else{
            Utility.notification('Something went wrong','Please try again later','error')
            console.error('Error in fetching products JSON: ',data)
        }
    }

    async _deleteSubscription(subscriptionId) {
        try {
            var config = {
                url: `/subscriptions/${subscriptionId}?commit=true&send_email=false`,
                method: 'DELETE',
                headers: {
                    "Accept": "application/json",
                    "X-Recharge-Version": "2021-11"
                }
            };

            await fetch(this.rechargeCommonApi(), this.rechargeCommonBody(config));

            return true;
        } catch (e) {
            return false;
        }

    }

    async _getPaymentMethods() {
        const response = await recharge.paymentMethod.listPaymentMethods(session, {
            limit: 25,
        });
        window.customerDetails.rechargePaymentMethods=response.payment_methods;
        return window.customerDetails.rechargePaymentMethods;
    }

    async _getCharges(config) {
        try {
            const response = await recharge.charge.listCharges(session, config);
            window.customerDetails.rechargeCharges=response.charges;
            return window.customerDetails.rechargeCharges;
        } catch (error) {
            // log the error message to the console
            console.log(error,'error')
            return [];
        }

    }

    async _processCharge(chargeID){
        try {
            const response = await recharge.charge.processCharge(session, chargeID);
            console.log(response,'response')
            return response;

        } catch (error) {
            // log the error message to the console
            console.log(error,'error')
            return false;
        }
    }

    async _skipCharge(chargeID,purchaseItemIds) {
        try {
            const response = await recharge.charge.skipCharge(session, chargeID, purchaseItemIds);
            console.log(response,'response')
            return true;
        } catch (error) {
            // log the error message to the console
            console.error(error,'error')
            if(error.status == 409){
              await new Promise(resolve => setTimeout(resolve, 2000));
              return await this._skipCharge(chargeID,purchaseItemIds)
            }else{
              return await false;
            }
        }
    }

    async _unskipCharge(chargeID,purchaseItemIds){
        try {
            const response = await recharge.charge.unskipCharge(session, chargeID, purchaseItemIds);
            console.log(response,'response')
            return true;
        } catch (error) {
            // log the error message to the console
            console.log(error,'error')
            if(error.status == 409){
              await new Promise(resolve => setTimeout(resolve, 2000));
              return await this._unskipCharge(chargeID,purchaseItemIds)
            }else{
              return false;
            }
        }
        
    }
    async _createBulkSubscriptions(subsDataObj,addressId){
        var config = { subscriptions: subsDataObj};

        const response = await fetch(`https://api.rechargeapps.com/addresses/${addressId}/subscriptions-bulk?shop_url=vlezunderwear.myshopify.com`, {
                            method: 'POST',
                            headers: this.header(),
                            body: JSON.stringify(config)
                        });
        const data = await response.json();

        // Added onetime addon
        if (response.ok) {
            console.log('Subscription created Successfully : ',data)
            return await true;
        }else{
            console.error('error in subscription creating : ',data)
        }
    }

    async _createSubscriptionProduct(config){
        try {
            const response = await recharge.subscription.createSubscription(session,config);
            return true;
        } catch (error) {
            return false;
        }
    }

    async _createOnetime(config){
        
        try {
            const response=await recharge.onetime.createOnetime(session, config);
            return true;
        } catch (error) {
            // log the error message to the console
            return false;
        }
    }

    async _updateSubscription(id,config){
        try {
            const response=await recharge.subscription.updateSubscription(session, id, config);
            console.log(response,'response')
            return true;
        } catch (error) {
            // log the error message to the console
            console.log(error,'error')
            if(error.status == 409){
                await new Promise(resolve => setTimeout(resolve, 2000));
                return await this._updateSubscriptions(id,config);
            }else{
                return await false;
            }
        }
    }

    async _updateSubscriptions(id,config,retryCount = 0){
        try {
            const response=await recharge.subscription.updateSubscriptions(session, id, config, { allow_onetimes: true });
            console.log(response,'response')
            return true;
        } catch (error) {
            // log the error message to the console
            console.log(error,'error')
            if(error.status == 409 && retryCount < 3){
                await new Promise(resolve => setTimeout(resolve, 2000));
                return await this._updateSubscriptions(id,config,retryCount + 1);
            }else{
                return await false;
            }
        }
    }

    async _mergeAddresses(config){
        try {
            const response=await recharge.address.mergeAddresses(session, config);
            console.log(response,'merge_response')
            return true;
        } catch (error) {
            // log the error message to the console
            console.log(error,'error')
            if(error.status == 409){
                await new Promise(resolve => setTimeout(resolve, 2000));
                return await this._mergeAddresses(config);
            }else{
                return await false;
            }
        }
    }

    async _deleteAddress(id){
        try {
            const response=await recharge.address.deleteAddress(session, id);
            console.log(response,'delete_addresses')
            return true;
        } catch (error) {
            // log the error message to the console
            console.log(error,'error')
            if(error.status == 409){
                await new Promise(resolve => setTimeout(resolve, 2000));
                return await this._deleteAddress(id);
            }else{
                return await false;
            }
        }
    }

    async _updateSubscriptionForOld(subscription_id,updateSubscriptionObj){
        var config = {
            url: `/subscriptions/${subscription_id}?commit=true`,
            method: 'PUT',
            data: updateSubscriptionObj,
            headers: {
                "Accept": "application/json",
                "X-Recharge-Version": "2021-11"
            }
        };

        const response = await fetch(this.rechargeCommonApi(), this.rechargeCommonBody(config));
        const data = await response.json();

        // Updated subscription
        if (response.ok) {
            console.log('Subscription Updated Successfully: ',data)
            return true;
        }else{
            console.error('error in updating subscription: ',data)
            return false;
        }
    }

    async _updateShippingAddress(id,config){
        try {
            const response=await recharge.address.updateAddress(session, id, config);
            return true;

        } catch (error) {
            // log the error message to the console
            console.log(error,'error')
            if(error.status == 409){
                await new Promise(resolve => setTimeout(resolve, 2000));
                return await this._updateShippingAddress(id,config);
            }else if(error.message && error.message.includes('zip code')){
                return 'Invalid zip code for selected province';
            }else{
                return await false;
            }
        }
    }
    async _removeOnetime(config) {
        try{
            const response= await recharge.onetime.deleteOnetime(session, config);
            return true;
        }catch(err){
            return await false;
        }
    }

    async _cancelSubscription(id,config){
        try {
            const response=await recharge.subscription.cancelSubscription(session, id, config);
            return true;
        } catch (error) {
            // log the error message to the console
            return false;
        }
    }

    async _createSubscriptionProduct(subsDataObj){
        try {
            await recharge.subscription.createSubscription(session, subsDataObj);
            return true;
        } catch (e) {
            console.log(e, 'subscription create error');
            return false;
        }
    }

    async _createSubscriptionProductForOld(subsDataObj){
        var config = {
            url: `/subscriptions`,
            method: 'POST',
            data: subsDataObj,
            headers: this.header()
        };

        const response = await fetch(this.rechargeCommonApi(), this.rechargeCommonBody(config));
        const data = await response.json();

        if (response.ok) {
            console.log('Subscription created Successfully: ',data)
            return true;
        }else{
            console.error('error in adding onetime Addon: ',data)
            return false;
        }
    }


    async _createOnetimeAddon(addonObj){
        var config = {
            url: `/onetimes`,
            method: 'POST',
            data: addonObj,
            headers: {
                "Accept": "application/json",
                "X-Recharge-Version": "2021-11"
            }
        };

        const response = await fetch(this.rechargeCommonApi(), this.rechargeCommonBody(config));
        const data = await response.json();

        // Added onetime addon
        if (response.ok) {
            console.log('Addon added Successfully: ',data)
            return await true;
        }else{
            console.error('error in adding onetime Addon: ',data)
            return await false;
        }
    }

    async _updatePaymethodMethod(payment_method_id,address_id){
         try{
            await recharge.customer.sendCustomerNotification(session, 'SHOPIFY_UPDATE_PAYMENT_INFO', {
                                                                  address_id: address_id,
                                                                  payment_method_id: payment_method_id,
                                                              });
           return true;
        }catch(err){
             console.error('error in update payment method: ',err)
            return false;
        }
    }
    async _getBundleId(bundle){
        try{
            return await recharge.bundle.getBundleId(bundle);
        }catch(err){
            console.error(err,'err');
            return false;
        }
    }

}
var rechargeSdk = new newRecharge();